import { render, staticRenderFns } from "./orgChange.vue?vue&type=template&id=3066d5be&scoped=true&"
import script from "./orgChange.vue?vue&type=script&lang=js&"
export * from "./orgChange.vue?vue&type=script&lang=js&"
import style0 from "./orgChange.vue?vue&type=style&index=0&id=3066d5be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3066d5be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3066d5be')) {
      api.createRecord('3066d5be', component.options)
    } else {
      api.reload('3066d5be', component.options)
    }
    module.hot.accept("./orgChange.vue?vue&type=template&id=3066d5be&scoped=true&", function () {
      api.rerender('3066d5be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authority/orgChange.vue"
export default component.exports